/**
 * Línguas da app. O inglês é a língua por omissão; o português de Portugal é a segunda.
 * Para acrescentar uma língua (ex.: pt-BR): juntá-la aqui e a cada catálogo (a verificação
 * de tipos diz onde falta).
 */
export const LOCALES = ['en', 'pt-PT'] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

/** Nome de cada língua na própria língua (para o seletor). */
export const LOCALE_NAMES: Record<Locale, string> = {
  en: 'English',
  'pt-PT': 'Português (Portugal)',
};

export const isLocale = (v: unknown): v is Locale =>
  typeof v === 'string' && (LOCALES as readonly string[]).includes(v);

/**
 * A língua a usar a partir das preferências do browser (navigator.languages, por ordem).
 * Enquanto não houver pt-BR, qualquer português usa pt-PT.
 */
export function matchLocale(tags: readonly (string | null | undefined)[]): Locale {
  for (const raw of tags) {
    const tag = (raw ?? '').trim();
    if (!tag) continue;
    if (isLocale(tag)) return tag;
    const lang = tag.toLowerCase().split(/[-_]/)[0];
    if (lang === 'pt') return 'pt-PT';
    if (lang === 'en') return 'en';
  }
  return DEFAULT_LOCALE;
}
